module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ae564de8d4f7ca1a034180221227e91b.png";